import { render, staticRenderFns } from "./PrivacyThirdParty_202608.vue?vue&type=template&id=534e77f0&scoped=true"
import script from "./PrivacyThirdParty_202608.vue?vue&type=script&lang=js"
export * from "./PrivacyThirdParty_202608.vue?vue&type=script&lang=js"
import style0 from "./PrivacyThirdParty_202608.vue?vue&type=style&index=0&id=534e77f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534e77f0",
  null
  
)

export default component.exports